import React from 'react';
import {
  BooleanField,
  Labeled,
  List,
  ShowButton,
  Show,
  SimpleShowLayout,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton, Filter, TextInput, ReferenceInput, SelectInput
} from 'react-admin';

function IntFlagField(props) {
  let { record } = props;
  record = Object.assign({}, record, { result: record[props.source] === 1 });

  let newProps = Object.assign({}, props, { record });

  return <BooleanField {...newProps} />

}

export const TrailReferences = (props) => {
  return <Datagrid {...props}>
    <TextField source="id"/>
    <ReferenceField label="Site" source="user_id" reference="user">
      <TextField source="domain" />
    </ReferenceField>
    <TextField source="type" />
    <IntFlagField label="Success" source="result" />
    <TextField source="ip_address" />
    <TextField source="country" />
    <TextField source="user_agent" />
  </Datagrid>;
};

const TrailListFilters = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Auth Id" source="auth_id" reference="auth">
      <TextInput />
    </ReferenceInput>
    <TextInput label="Country" source="country" />
    <ReferenceInput label="Site" source="user_id" reference="user" allowEmpty>
      <SelectInput optionText="domain" />
    </ReferenceInput>
  </Filter>
);

export const TrailList = (props) => (
  <List {...props} filters={<TrailListFilters />} bulkActions={false}>
    <Datagrid>
      <ReferenceField label="Auth" source="auth_id" reference="auth" linkType="show">
        <TextField source="id" />
      </ReferenceField>
      <ReferenceField label="Site" source="user_id" reference="user" linkType="show">
        <TextField source="domain" />
      </ReferenceField>
      <TextField source="type" />
      <IntFlagField label="Success" source="result" />
      <TextField source="ip_address" />
      <TextField source="country" />
      <TextField source="user_agent" />
    </Datagrid>
  </List>
);


// WEBPACK FOOTER //
// ./resources/assets/js/trail.js